<audio type="audio/mpeg" #audioRef (ended)="setStatusPaused()" (timeupdate)="updateTime($event)" (durationchange)="updateDuration($event)"></audio>
@if (sermon()) {
  <div class="zwi-player__container bg-card/95 backdrop-blur-md border rounded-lg shadow-lg" [class]="{'zwi-player__container-lg': isTablet()}">
    @if (isMobile() == false) {
      <div class="zwi-player__progress-slider-container">
        <zwi-progress-slider (timeChange)="changeTime($event)" [sermon]="sermon()" [duration]="duration"></zwi-progress-slider>
      </div>
    }

    <div class="zwi-player-wrapper p-4">
      <div class="zwi-player-content">
        <img width="30px" [src]="sermon()?.ministry?.profileImage" [alt]="sermon()?.ministry?.name" class="zwi-player-avatar">
        <div #informationElement class="zwi-player__information" [ngClass]="{'zwi-player__information--mobile': isMobile}" style="overflow: hidden;">
          <div #nameElement class="mat-subtitle-2 zwi-nowrap zwi-player-name">
            @if (shouldScroll()) {
              <marquee scrollamount="5">{{ name() }}</marquee>
            } @else {
              <span>{{ name() }}</span>
            }
          </div>
          @if (isMobile()) {
            @if (audioRef.readyState > 0) {
              <div class="mat-caption zwi-player__information__caption">{{ remainingTime() }}</div>
            }
          } @else if (hasReferences()) {
            <div class="mat-caption zwi-player__information__caption">{{ getReferences(sermon()?.references) }}</div>
          }
        </div>
      </div>
      <div class="zwi-player__middle">
        <button matIconButton [disabled]="!sermon()" (click)="subtractThirtySeconds()" [class]="{'zwi-player__button': isMobile()}">
          <mat-icon>replay_30</mat-icon>
        </button>
        <zwi-player-button [sermon]="sermon()" [status]="status" (changePlay)="updateStatus($event)"></zwi-player-button>
        @if (isMobile() === false) {
          <button mat-icon-button [disabled]="!sermon()" (click)="addThirtySeconds()">
            <mat-icon>forward_30</mat-icon>
          </button>
        }
      </div>
      @if (isMobile() == false) {
        <div class="flex justify-end">
          <zwi-time-display [currentTime]="currentTime()"></zwi-time-display>
          <div>&nbsp;/&nbsp;</div>
          <zwi-time-display [currentTime]="duration"></zwi-time-display>
        </div>
      }
    </div>
  </div>
}
